import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
import { AppProviders } from './providers'

ReactDOM.render(
  <AppProviders>
    <App />
  </AppProviders>,
  document.getElementById('app')
)
